import { useQuery } from "@tanstack/react-query";
import { CACHE_KEY_EVALUATIONCRITERIA } from "../../../../utils/constants";
import { EvaluationCriteriaInterface } from "../../../../models/ProcurementModule/EvaluationCriteria";
import EvaluationCriteriaService from "../../../../services/procurementService/EvaluationCriteriaService";

const useEvaluationCriteria = (page: number, pageSize: number) =>
  useQuery<EvaluationCriteriaInterface[], Error>({
    queryKey: [CACHE_KEY_EVALUATIONCRITERIA, page, pageSize],
    queryFn: () => EvaluationCriteriaService.GetAll(page, pageSize),
    initialData: [],
  });

export default useEvaluationCriteria;
